<template>
  <div class=" formgrid grid p-2" style="padding-top: 0 !important; padding-bottom: 0 !important;" >
    <div class="field col-12 md:col-2">
      <label for="cep" class="required">CEP</label>
      <ValidationProvider name="CEP" rules="required" v-slot="{ errors }" mode="lazy">
        <InputMask id="cep" v-model="usuario.cep"
          mask="99999-999" @change="setEndereco()" :class="{ 'field-invalid': errors[0] }"/>
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>

    <div class="field col-12 md:col-8">
      <label for="endereco" class="required">Logradouro</label>
      <ValidationProvider name="Endereço" rules="required" v-slot="{ errors }" mode="lazy">
        <InputText id="endereco" type="text" v-model="usuario.logradouro" :class="{ 'field-invalid': errors[0] }"/>
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>
    <div class="field col-12 md:col-2 ">
      <label for="numero" class="required">Número</label>
      <ValidationProvider name="Numero" rules="required" v-slot="{ errors }" mode="lazy">
        <InputNumber id="numero" v-model="usuario.numero" :class="{ 'field-invalid': errors[0] }"/>
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>

    <div class="field col-12 md:col-7">
      <label for="complemento">Complemento</label>
      <InputText id="complemento" type="text" v-model="usuario.complemento" />
    </div>

    <div class="field col-12 md:col-5">
      <label for="bairro" class="required">Bairro</label>
      <ValidationProvider name="Bairro" rules="required" v-slot="{ errors }" mode="lazy">
        <InputText id="bairro" placeholder="Bairro" v-model="usuario.bairro" :class="{ 'field-invalid': errors[0] }"/>
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>

    <div class="field col-12 md:col-6">
      <label for="estado" class="required">Estado</label>
      <ValidationProvider
        name="Estado"
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
      >
        <Dropdown
          id="estado"
          v-model="estadoSelecionado"
          :options="dropdownEstados"
          @change="setCidades()"
          optionLabel="sigla"
          placeholder="Estado ..."
          :class="{ 'field-invalid': errors[0] }"
        />
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>
    <div class="field col-12 md:col-6">
      <label for="cidade" class="required">Cidade</label>
      <ValidationProvider
        name="Cidade"
        rules="required"
        v-slot="{ errors }"
        mode="lazy"
      >
        <Dropdown
          id="cidade"
          v-model="usuario.cidade"
          :options="dropdownCidades"
          placeholder="Cidade ..."
          :class="{ 'field-invalid': errors[0] }"
        />
        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { validacaoFormulario } from "@/validacaoFormulario";
import EstatosCidadesService from "../service/EstadosCidadesService";
import axios from "axios";
export default {
  mixins: [validacaoFormulario],

  props: ["usuario"],

  data() {
    return {
      dropdownEstados: [],
      dropdownCidades: [],
      estadoSelecionado: [],
      estatosCidadesService: null,
    };
  },


  created() {

		console.log('criou ...', this.usuario.uf);


      this.estatosCidadesService = new EstatosCidadesService();



  },

  mounted() {
    	console.log('montou ...', this.usuario.uf);

      this.estatosCidadesService.getEstadosCidades().then((data) => {
      this.dropdownEstados = data;
      this.estadoSelecionado = this.getEstadoBySigla(this.usuario.uf);
      this.setCidades();


      // this.setEndereco();
    });
  },

  methods: {
    setEndereco() {

      console.log(this.usuario.cep)
      axios
        .get(`https://viacep.com.br/ws/${this.usuario.cep}/json/`)
        .then((resposta) => {
          console.log("endereco", resposta.data);
          this.usuario.logradouro = resposta.data.logradouro;
          this.usuario.bairro = resposta.data.bairro;
          this.usuario.cidade = resposta.data.localidade;
          this.usuario.uf = resposta.data.uf;
          this.estadoSelecionado = this.getEstadoBySigla(this.usuario.uf);
          this.setCidades();
        })
        .catch((erro) => console.error(erro));
    },
    setCidades() {
      if (this.estadoSelecionado) {
        this.dropdownCidades = this.estadoSelecionado.cidades;
        this.usuario.uf = this.estadoSelecionado.sigla;
      }
    },

    getEstadoBySigla(sigla) {
      let estado = [];
      for (let i = 0; i < this.dropdownEstados.length; i++) {
        if (this.dropdownEstados[i].sigla === sigla) {
          estado = this.dropdownEstados[i];
          break;
        }
      }
      return estado;
    },
  },
};
</script>
